import { SubscriptionPayment } from '@models/membership/SubscriptionPayment'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_SUBSCRIPTION_PAYMENTS_URL } from '@utils/urls'

const fetchSubscriptionPayments = (params: TableParams) =>
  SBAPI.FetchPaginated<SubscriptionPayment[]>(
    MEMBERSHIP_SUBSCRIPTION_PAYMENTS_URL,
    params
  )

export { fetchSubscriptionPayments }
